// import i18n from '../../../lang/i18n'
import { Toast } from 'antd-mobile'

// 感觉，好像可以不这么做...
const toast = {
  loading: props => Toast.show({
    icon: 'loading',
    // content: i18n.t('common.loading'),
    ...props
  }),
  success: props => Toast.show({
    icon: 'success',
    ...props
  }),
  fail: props => Toast.show({
    icon: 'fail',
    ...props
  }),
  show: props => Toast.show(props),
  clear: () => Toast.clear()
}

const feedback = {
  toast
}

export default feedback